import { connect } from 'react-redux';
import { Card, Row, Col } from 'react-bootstrap';
import PropertySwitch from './components/PropertySwitch';
import BaseFeature from './BaseFeature';
import { POWER_ON_DELAY } from '../../../../../../utils/constantFeatures';
import PropertyPicker from './components/PropertyPicker';
import { Trans } from 'react-i18next';

class PowerOnDelay extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
            podEnabled: this.props.properties[POWER_ON_DELAY.enable].value === "1" ? true : false,
            podDimmingLevel: this.props.properties[POWER_ON_DELAY.dimLevel].value,
            podTimeDelay: this.props.properties[POWER_ON_DELAY.delay].valueMeta,
        };

        this.handleChange = this.handleChange.bind(this);

    }

    handleChange(propertyName, value) {
        const v = value;
        const newState = {[propertyName]:value};

        this.setState(newState);

        const state = { ...this.state, ...newState };
        // this.setState({ dimmingEnabled: v === "1" ? true : false });

        this.props.handleChange(propertyName, v);
    }

    render() {

        return (
            <><Row>
                <Col sm={3}>
                    <Card className="card-feature-component" style={{ width: '100%'}}>
                        <div className="card-header-feature">
                            <Trans i18nKey="Custom_Power_On_Delay" />
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem'}} >
                            <PropertySwitch
                                property={this.props.properties[POWER_ON_DELAY.enable]}
                                title={this.props.properties[POWER_ON_DELAY.enable].info.displayName}
                                handleChange={this.handleChange} />

                            <PropertyPicker
                                disabled={this.props.properties[POWER_ON_DELAY.enable].value === '1' ? false : true}
                                property={this.props.properties[POWER_ON_DELAY.dimLevel]}
                                title={this.props.properties[POWER_ON_DELAY.dimLevel].info.displayName + " (%)"}
                                margin="0.75rem auto"
                                // measureUnit={this.props.properties[DIMMING.dimmingMin].info.unit}
                                min={this.props.properties[POWER_ON_DELAY.dimLevel].valueMeta.min}
                                max={this.props.properties[POWER_ON_DELAY.dimLevel].valueMeta.max}
                                inputStyle={{ padding: "0", maxWidth: "auto" }}
                                titleSize={6}
                                inputSize={6}
                                step={1}
                                handleChange={this.handleChange} />

                            <PropertyPicker
                                disabled={this.props.properties[POWER_ON_DELAY.enable].value === '1' ? false : true}
                                property={this.props.properties[POWER_ON_DELAY.delay]}
                                title={this.props.properties[POWER_ON_DELAY.delay].info.displayName + " (sec)"}
                                margin="0.75rem auto"
                                // measureUnit={this.props.properties[DIMMING.dimmingMin].info.unit}
                                min={this.props.properties[POWER_ON_DELAY.delay].valueMeta.min}
                                max={this.props.properties[POWER_ON_DELAY.delay].valueMeta.max}
                                inputStyle={{ padding: "0", maxWidth: "auto" }}
                                titleSize={6}
                                inputSize={6}
                                step={1}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                </Col>

            </Row></>
        );
    }

}

export default connect(
    // mapStateToProps,
    // mapDispatchToProps
)(PowerOnDelay);
